import round from "./round";

type FractSize = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12; // для запрета ввода отриацательного размера дробной части

// Функция форматирует число: 123456 => 123 456.00 (количество знаков после запятой по дефолту равно 2)
const formatNumber = (numstr: string | number, fractSize?: FractSize): string => {
  if (typeof numstr !== "string" && typeof numstr !== "number") return ""; // проверки нужны для использования в js файлах
  if (Number.isNaN(numstr)) return "";
  const currentFractSize: FractSize = fractSize === undefined ? 2 : fractSize;

  const [integer, fractional] = round(numstr, currentFractSize).split(".");
  const partsOfInteger: string[] = [];
  for (let i = integer.length; i >= 0; i -= 3) {
    const startPos = i - 3 >= 0 ? i - 3 : 0;
    const currentPart: string = integer.slice(startPos, i);
    partsOfInteger.unshift(currentPart);
  }
  if (currentFractSize === 0) return `${partsOfInteger.join(" ")}`;
  return `${partsOfInteger.join(" ")}.${fractional}`;
};

export default formatNumber;
